<template>
	<img
		v-if="authenticated"
		height="1"
		width="1"
		alt=""
		style="display: none"
		:src="`https://i.prefinery.com/projects/${projectId}/users/checkin.gif?email=${email}`"
	/>
</template>

<script>
import { setAuthState } from '../composables/auth';

export default {
	setup() {
		const { isAuthenticated, getUser } = setAuthState();

		// change here
		const projectId = 'wynknsfn';
		return {
			projectId,
			getUser,
			isAuthenticated,
		};
	},

	computed: {
		authenticated() {
			return this.isAuthenticated();
		},

		email() {
			return encodeURIComponent(this.getUser()?.email);
		},
	},
};
</script>


